<template>
	<div class="single-service" v-if="currentPage">
		<section class="service-header bg-light">
			<div class="main-content">
				<div class="title-line">
					<h1 v-html="currentPage.title.rendered"></h1>
					<wpLink 
                    :url="archive" 
					:type="true"
                    v-html="'Se alle tjenester'" />
				</div>
				<template v-if="currentPage.acf && currentPage.acf.intro">
					<div class="service-info">
						<p class="intro" v-html="currentPage.acf.intro"></p>
					</div>
				</template>
			</div>
		</section>
		<section class="main-content service-main">
			
			<div class="service-content">

				<section v-if="currentPage.acf.description">
					<DynamicHtml :html="currentPage.acf.description" />
				</section>
				<relatedPosts :data="currentPage.acf.related_projects.items" type="projects" />
				
			</div>

			<div class="sidebar bg-light" v-if="currentPage.acf && currentPage.acf.employee">

				<h3 v-html="currentPage.acf.contact_title"></h3>
				<employeeBlock v-for="(empId, i) in currentPage.acf.employee" :key="i" :id="empId" :type="postType"/>

			</div>

		</section>
	</div>
	<div v-else class="nothing single-page"></div>
</template>

<script>

import employeeBlock from '@/components/blocks/EmployeeBlock'
import relatedPosts from '@/components/modules/RelatedPosts'
import wpLink from '@/components/navigation/WpLink'

export default {
	name: 'single-service',
	data(){
		return{
			archive: this.$route.meta.archive,
		}
	},
	components: {
		relatedPosts,
		employeeBlock,
		wpLink
	},
	computed: {
        postType(){
            return this.type || 'employees'
        }
    },
}
</script>

